import { render, staticRenderFns } from "./ActivePropertyTable.vue?vue&type=template&id=12ea86e6&"
import script from "./ActivePropertyTable.vue?vue&type=script&lang=js&"
export * from "./ActivePropertyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports